import { FORMULAS_HTML_TAG } from './FormulaChip/formulas.const';
import { DATA_CHIP_HTML_TAG, TEXT_PARSER_HTML_TAG, MULTI_SELECT_CHIP_HTML_TAG } from './DataChip/data-chip.const';

export const ALL_CUSTOM_HTML_TAGS = [DATA_CHIP_HTML_TAG, FORMULAS_HTML_TAG, TEXT_PARSER_HTML_TAG, MULTI_SELECT_CHIP_HTML_TAG];

export const HTML = 'html';
export const MARKDOWN = 'markdown';
export const PLAIN_TEXT = 'plain_text';

export const TEXT_BOX_FORMAT_TYPES = {
	HTML,
	MARKDOWN,
	PLAIN_TEXT,
};
